import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { I18nModule } from '@recruitee/i18n';

import { TooltipModule } from '../../tooltip/tooltip.module';
import { SegmentedControlButtonComponent } from './segmented-control-button.component';

@NgModule({
  exports: [SegmentedControlButtonComponent],
  imports: [CommonModule, I18nModule, TooltipModule, SegmentedControlButtonComponent],
})
export class SegmentedControlButtonModule {}
export {
  LanguageSwitcherItem,
  SegmentedControlButtonComponent,
  segmentedButtonType,
} from './segmented-control-button.component';
